import React, { Dispatch } from 'react';
import '../../App.css';
import HotwashTurn from './HotwashTurn'
import RGLHotwash from './RGLHotwash'
import { IInjectInfo, IHotwash, IGameStatus, IScenario } from '../../interfaces';

interface TurnTimelineProps {
    setHotwashInjects: Dispatch<any>;
    hotwashInjects: IInjectInfo[];
    setInjectItem: Dispatch<any>;
    injectItem: IInjectInfo; 
    gameTimeInterval: number;
    showHotwashTurnTimeline: string;
    setShowHotwashNodeTimeline: Dispatch<any>;
    setShowHotwashTurnTimeline: Dispatch<any>;
    hotwashStatus: IHotwash;
    updateHotwashStatus: Dispatch<any>;
    isHost: boolean;
    currentGame: IGameStatus;
    zoomLevel: number;
    setZoomLevel: Dispatch<any>;
    setLastUserClick: Dispatch<any>;
    lastUserClick: string;
    selectedScenario: IScenario;
  }

const HotwashTurnTimeline: React.FC<TurnTimelineProps> = ({ setHotwashInjects, hotwashInjects, setInjectItem, injectItem, gameTimeInterval, showHotwashTurnTimeline, setShowHotwashNodeTimeline, setShowHotwashTurnTimeline, hotwashStatus, updateHotwashStatus, isHost, currentGame, zoomLevel, setZoomLevel, setLastUserClick, lastUserClick, selectedScenario }) => {

    let turnLength: number = 0;
    if (zoomLevel === 5) {
      turnLength = 184;
    } else {
      turnLength = 360;
    }

    let turnWrapper: string;
    turnWrapper = gameTimeInterval * turnLength + 300 + 'px'
    
    return (
        <div>
            <div className={`hotwash-turn-content ${showHotwashTurnTimeline}`}>
                <div className="turns-wrapper" style={{'width':turnWrapper }}>
                <RGLHotwash display='block' gameTimeInterval={selectedScenario.gameTimeInterval} isSelected={''} setInjectItem={setInjectItem} injectItem={injectItem} id={'1'} key={1} zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} selectedScenario={selectedScenario} lastUserClick={lastUserClick} setLastUserClick={setLastUserClick} hotwashInjects={hotwashInjects} setHotwashInjects={setHotwashInjects} hotwashStatus={hotwashStatus} currentGame={currentGame} isHost={isHost} updateHotwashStatus={updateHotwashStatus} setShowHotwashNodeTimeline={setShowHotwashNodeTimeline} setShowHotwashTurnTimeline={setShowHotwashTurnTimeline} />
                    <div className="turn-gutter">
                        <div className="turn-start-scenario">
                            <span>Scenario Start</span>
                        </div>
                    </div>
                    {Array.from({length: gameTimeInterval}, (item, index) => 
                        <div key={index} className="turn-wrapper" style={{ width: turnLength + 'px'}}>
                            <HotwashTurn setHotwashInjects={setHotwashInjects} hotwashInjects={hotwashInjects} setInjectItem={setInjectItem} injectItem={injectItem} turn={index+1} hotwashStatus={hotwashStatus} setShowHotwashNodeTimeline={setShowHotwashNodeTimeline} setShowHotwashTurnTimeline={setShowHotwashTurnTimeline} gameTimeInterval={gameTimeInterval} updateHotwashStatus={updateHotwashStatus} isHost={isHost} currentGame={currentGame} zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default HotwashTurnTimeline;